import { render, staticRenderFns } from "./catalog-item-inline-editor.vue?vue&type=template&id=8438a1d4&scoped=true&"
import script from "./catalog-item-inline-editor.vue?vue&type=script&lang=js&"
export * from "./catalog-item-inline-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8438a1d4",
  null
  
)

export default component.exports